export function formatCnpj(cnpj) {
    if (!cnpj)
        return '';
    const cleaned = cnpj.replace(/\D/g, '');
    if (cleaned.length !== 14)
        return cnpj;
    return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}
export function formatCpf(cpf) {
    if (!cpf)
        return '';
    const cleaned = cpf.replace(/\D/g, '');
    if (cleaned.length !== 11)
        return cpf;
    return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
}
export function formatCurrency(value, currency = 'BRL') {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency,
    }).format(value);
}
export function formatLocalDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function maskEmail(email) {
    if (!email || typeof email !== 'string' || !email.includes('@'))
        return '';
    const [user, domain] = email.split('@');
    const isAlreadyMasked = email.includes('*');
    let userStart;
    let domainEnd;
    if (isAlreadyMasked) {
        userStart = user.replace(/\*+.*$/, '');
        const rawDomainEnd = domain.replace(/^\*+/, '');
        let letterCount = 0;
        domainEnd = '';
        for (let i = rawDomainEnd.length - 1; i >= 0 && letterCount < 7; i--) {
            domainEnd = rawDomainEnd[i] + domainEnd;
            if (/[a-zA-Z]/.test(rawDomainEnd[i])) {
                letterCount++;
            }
        }
    }
    else {
        userStart = user.slice(0, Math.min(2, user.length));
        let letterCount = 0;
        domainEnd = '';
        for (let i = domain.length - 1; i >= 0 && letterCount < 7; i--) {
            domainEnd = domain[i] + domainEnd;
            if (/[a-zA-Z]/.test(domain[i])) {
                letterCount++;
            }
        }
    }
    const fixedUserMask = '*******';
    const fixedDomainMask = '****';
    return `${userStart}${fixedUserMask}@${fixedDomainMask}${domainEnd}`;
}
export function maskPhone(phone) {
    if (!phone || typeof phone !== 'string')
        return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length < 4)
        return '';
    const lastFour = digits.slice(-4);
    return `(**) *****-${lastFour}`;
}
export function isEmptyObject(value) {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    if (value.constructor !== Object) {
        return false;
    }
    return Object.keys(value).length === 0;
}
export function isMaskedValue(value) {
    return typeof value === 'string' && value.includes('*');
}
export function sanitizeAccountMaskAware(value) {
    if (value === undefined || value === null) {
        return undefined;
    }
    if (isMaskedValue(value)) {
        return value;
    }
    return value.replace(/\D/g, '');
}
